import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "whitespaceBlock" }

import { computed } from 'vue';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'WhitespaceBlock',
  props: {
    block: null
  },
  setup(__props: any) {

const props = __props as {block:{fields:{ DesktopHeightInPx: number; MobileHeightInPx: number }}}

_useCssVars(_ctx => ({
  "fea21a68": (mobileHeight),
  "749aee60": (desktopHeight)
}))

  

  const mobileHeight = `${props.block.fields.MobileHeightInPx || 0}px`;
  const desktopHeight = `${props.block.fields.DesktopHeightInPx || 0}px`;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})